
namespace SorAraBul {

    /**
     * This is an editor widget but it only displays a text, not edits it.
     *  
     */
    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.registerEditor([Serenity.ISetEditValue])
    export class CustomStaticTextBlock extends Serenity.Widget<StaticTextBlockOptions>
        implements Serenity.ISetEditValue {

        private value: string;

        constructor(container: JQuery, options: StaticTextBlockOptions) {
            super(container, options);

            // hide the caption label for this editor if in a form. ugly hack
            if (this.options.hideLabel)
                this.element.closest('.field').find('.caption').hide();

            this.updateElementContent();
        }

        private updateElementContent() {
            var text = Q.coalesce(this.options.text, this.value);

            // if isLocalText is set, text is actually a local text key

            if (this.options.isDate)
                text = Q.formatDate(text);

            if (this.options.isDateTime)
                text = Q.formatDate(text, Q.Culture.dateTimeFormat);

            if (this.options.isLocalText)
                text = Q.text(text);

            if (this.options.isTimestamp && Q.isValue(text)) {
                text = new Date(text).toLocaleString("tr-TR");
            }

            if (this.options.isTimestampAndToUTCString && Q.isValue(text)) {
                text = new Date(text).toLocaleString("tr-TR", { timeZone: "UTC" });
            }

            if (this.options.isEnum) {
                text = Serenity.EnumFormatter.format(Serenity.EnumTypeRegistry.get(this.options["enumKey"]), this.value);
            }

            if (this.options.isBoolean) {
                text = (this.value ? "Evet" : "Hayır");
            }

            // don't html encode if isHtml option is true
            if (this.options.isHtml)
                this.element.html(text);
            else
                this.element.text(text);
        }

        /**
         * By implementing ISetEditValue interface, we allow this editor to display its field value.
         * But only do this when our text content is not explicitly set in options
         */
        public setEditValue(source: any, property: Serenity.PropertyItem) {
            if (this.options.text == null) {
                this.value = Q.coalesce(this.options.text, source[property.name]);
                this.updateElementContent();
            }
        }
    }

    export interface StaticTextBlockOptions {
        text: string;
        isHtml: boolean;
        isLocalText: boolean;
        hideLabel: boolean;
        isDate: boolean;
        isDateTime: boolean;
        isTimestamp: boolean;
        isTimestampAndToUTCString: boolean;
        isEnum: boolean;
        isBoolean: boolean;
    }
}